import React from 'react';

import { Icon } from '@rbilabs/components-library';
import { useTheme } from 'styled-components';

import { LoadingAnimation } from 'components/loading-animation';

import {
  IconWrapper,
  PinnedLocation,
  PinnedLocationDetails,
  PinnedLocationSubtitle,
  PinnedLocationTitle,
  TextWrapper,
} from './styled';

export interface ILocationDetailsProps {
  mainText?: string;
  secondaryText: string;
  isLoading?: boolean;
}

export const LocationDetails = ({ mainText, secondaryText, isLoading }: ILocationDetailsProps) => {
  const { token } = useTheme();

  return (
    <PinnedLocation>
      <PinnedLocationDetails>
        <IconWrapper>
          <Icon
            icon="location"
            color={token('text-default')}
            aria-hidden
            width="24px"
            height="24px"
          />
        </IconWrapper>
        {isLoading ? (
          <LoadingAnimation fillColor={token('text-default')} />
        ) : (
          <TextWrapper>
            {mainText && <PinnedLocationTitle>{mainText}</PinnedLocationTitle>}
            <PinnedLocationSubtitle>{secondaryText}</PinnedLocationSubtitle>
          </TextWrapper>
        )}
      </PinnedLocationDetails>
    </PinnedLocation>
  );
};
